import { render } from "./HeaderProductDangerZone.vue?vue&type=template&id=538d4d9a&scoped=true"
import script from "./HeaderProductDangerZone.vue?vue&type=script&lang=js"
export * from "./HeaderProductDangerZone.vue?vue&type=script&lang=js"

import "./HeaderProductDangerZone.vue?vue&type=style&index=0&id=538d4d9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538d4d9a"]])

export default __exports__